export default class StandingsHelper {
  constructor(standingsData) {
    this.data = standingsData.standings;
  }

  getStandingsForTeam(teamId) {
    const standings = this.data.filter((st) => st.team === teamId);
    if (standings.length === 1) return standings[0];
    return null;
  }

  getRecordForTeam(teamId) {
    const st = this.getStandingsForTeam(teamId);
    if (st && st.recordTotal) {
      return st.recordTotal;
    }
    return null;
  }

  getRecordForTeamAsStr(teamId) {
    const record = this.getRecordForTeam(teamId);
    if (record) {
      const elements = [record.wins, record.losses];
      if (record.ties) elements.push(record.ties);
      return elements.join("-");
    }
    return null;
  }
}
